import { FormikTextAreaField } from 'components/FormikTextAreaField/FormikTextAreaField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface CommentValues {
  comment?: string;
}

interface Props<T extends CommentValues> {
  formik: FormikProps<T>;
}

export const FormikVendorApiCommentField = <T extends CommentValues>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: {
        labels: { comment: commentMsg },
      },
    },
  } = useLocale();
  return (
    <FormikTextAreaField
      formik={props.formik}
      name='comment'
      label={commentMsg}
    />
  );
};
